<mat-dialog-actions>
  <mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<div class="container" *ngIf="htmlContent" [innerHTML]="htmlContent">
</div> 
<div class="container">
  <ng-container [ngTemplateOutlet]="templateRef"></ng-container>
</div>